import { Fragment } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

/** @jsxImportSource react */
function convertNewlineToJSX(str) {
  var chunks = str.replace(/\\n/g, '\n').split('\n');
  return chunks.map(function (line, index) {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [index > 0 ? /*#__PURE__*/jsx("br", {}) : '', line]
    }, index);
  });
}

export { convertNewlineToJSX as default };
